import { UbiverseSequenceNote } from "../../types"
import CONST from "../../consts"

export const convertSequenceToData = (sequences: UbiverseSequenceNote[], playheadTime: number, numerator: number, bpm: number): number[]  => {
  const filterPairsNonNegative = (arr: number[]) => {
    const out = []
    for (let i = 0; i < arr.length; i += 2) {
      const pair = arr.slice(i, i + 2)
      if (pair.some(n => n < 0)) continue
      out.push(...pair)
    }
    return out
  }

  let data: number[] = [];
  sequences.forEach(s => {
    data = [...data, ...convertSequenceNoteToData(s, playheadTime, numerator, bpm)]
  })
  return filterPairsNonNegative(data)
}

export const convertSequenceNoteToData = (sequence: UbiverseSequenceNote, playheadTime: number, numerator: number, bpm: number): number[] => {
  const { intensity, position } = sequence;
  const delay = CONST.sampleDelay.reference[intensity - 1]
  const quarterNoteDuration = 60 / bpm
  const playheadTimeBySample = playheadTime / CONST.sampleDelay.secondsPerSample
  const positionBySample = Math.round( (position * quarterNoteDuration) / CONST.sampleDelay.secondsPerSample - playheadTimeBySample ) + CONST.sampleDelay.reference[CONST.sampleDelay.reference.length - 1]
  return [positionBySample - delay, positionBySample]
}